// tslint:disable
/**
 * Notification api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Notification } from '../models';
import { NotificationList } from '../models';
/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} [companyId] 
         * @param {boolean} [read] 
         * @param {Date} [readAtMin] 
         * @param {Date} [readAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'readAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotification(userId: string, companyId?: string, read?: boolean, readAtMin?: Date, readAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'readAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling listNotification.');
            }
            const localVarPath = `/notifications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (read !== undefined) {
                localVarQueryParameter['read'] = read;
            }

            if (readAtMin !== undefined) {
                localVarQueryParameter['readAtMin'] = (readAtMin as any).toISOString();
            }

            if (readAtMax !== undefined) {
                localVarQueryParameter['readAtMax'] = (readAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all notification by current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllNotification(options: any = {}): RequestArgs {
            const localVarPath = `/notification/read/all`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotification(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling readNotification.');
            }
            const localVarPath = `/notification/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} [companyId] 
         * @param {boolean} [read] 
         * @param {Date} [readAtMin] 
         * @param {Date} [readAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'readAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotification(userId: string, companyId?: string, read?: boolean, readAtMin?: Date, readAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'readAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationList> {
            const localVarAxiosArgs = NotificationApiAxiosParamCreator(configuration).listNotification(userId, companyId, read, readAtMin, readAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Read all notification by current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllNotification(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = NotificationApiAxiosParamCreator(configuration).readAllNotification(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotification(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification> {
            const localVarAxiosArgs = NotificationApiAxiosParamCreator(configuration).readNotification(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} [companyId] 
         * @param {boolean} [read] 
         * @param {Date} [readAtMin] 
         * @param {Date} [readAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'readAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotification(userId: string, companyId?: string, read?: boolean, readAtMin?: Date, readAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'readAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return NotificationApiFp(configuration).listNotification(userId, companyId, read, readAtMin, readAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * Read all notification by current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllNotification(options?: any) {
            return NotificationApiFp(configuration).readAllNotification(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotification(id: string, options?: any) {
            return NotificationApiFp(configuration).readNotification(id, options)(axios, basePath);
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @param {string} userId 
     * @param {string} [companyId] 
     * @param {boolean} [read] 
     * @param {Date} [readAtMin] 
     * @param {Date} [readAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'readAt' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public listNotification(userId: string, companyId?: string, read?: boolean, readAtMin?: Date, readAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'readAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return NotificationApiFp(this.configuration).listNotification(userId, companyId, read, readAtMin, readAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * Read all notification by current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public readAllNotification(options?: any) {
        return NotificationApiFp(this.configuration).readAllNotification(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public readNotification(id: string, options?: any) {
        return NotificationApiFp(this.configuration).readNotification(id, options)(this.axios, this.basePath);
    }

}
